import './App.css';
import {Header} from './components/Header'
import {Home} from './components/Home'
import {HowToUse} from './components/HowToUse';
import {AboutSaveIT} from './components/AboutSaveIT';
import {ContactMe} from './components/ContactMe';
import {Footer} from './components/Footer'

function App() {
  return (
    <>
      <div>
        <Header/>
      </div>
      <div>
        <Home/>
      </div>
      <HowToUse/>
      <AboutSaveIT/>
      <ContactMe/>
      <div>
        <Footer/>
      </div>
    </>
  );
}

export default App;

